import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import { Link } from 'gatsby'
import { interactiveText } from 'components/magic/styled'
import colors from 'styles/colors'

const Wrapper = styled.nav`
  display: flex;
  align-items: center;
  flex: 1 1 auto;

  ${mediaQuery.mobile} {
    flex-direction: column;
    justify-content: center;
    color: ${colors.white};
  }
`

const NavLink = styled(Link).attrs({
  activeClassName: 'active',
  partiallyActive: true,
})`
  color: currentColor;
  font-weight: 600;
  font-size: 14px;
  line-height: 28px;
  text-decoration: none;
  padding: 0 15px;

  ${mediaQuery.tabletMax} {
    padding: 0 15px;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 48px;
  }

  &.active {
    ${interactiveText};
  }

  &:hover {
    opacity: 0.9;
  }
`

const Navigation = () => (
  <Wrapper>
    <NavLink to="/magic-os" activeClassName="active">
      About MagicOs
    </NavLink>
    <NavLink to="/ecosystem" activeClassName="active">
      Flip Ecosystem
    </NavLink>
    <NavLink to="/product" activeClassName="active">
      The Product
    </NavLink>
  </Wrapper>
)

export default Navigation
